import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface AddPaymentInfo extends GtagEvent{
    currency:ISO_4217;
    value: number;
    coupon?:string;
    payment_type?:string;
    items:Item[]
}
export const add_payment_info = ($_:AddPaymentInfo) => event('add_payment_info',$_);